<template>
    <div>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <el-button type="primary" size="mini" @click="screen">部门筛选</el-button>
                <el-button type="primary" size="mini" @click="search">查询</el-button>
                <el-button type="primary" size="mini" @click="imp">导入</el-button>
                <el-table
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        stripe
                        size="mini"
                        :height="tableHeight"
                        header-row-class-name="headerclass"
                        style="width: 100%; margin-top:0px"
                        @row-click="editInfo"
                        @row-dblclick="openEdit"
                        :data="dataSet"
                >
                    <el-table-column prop="bm" label="部门" ></el-table-column>
                    <el-table-column prop="d1" label="22年人件费1-11月" align="right">
                        <template slot-scope="scope">
                            {{scope.row.d1 | thousandth}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="d2" label="22年平均人数" align="right"></el-table-column>
                    <el-table-column prop="d3" label="人均" >
                        <template slot-scope="scope">
                            {{scope.row.d3 | thousandth}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="d4" label="人事编制人数" align="right"></el-table-column>
                    <el-table-column prop="d5" label="月均" >
                        <template slot-scope="scope">
                            {{scope.row.d5 | thousandth}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="d6" label="年人件费" align="right">
                        <template slot-scope="scope">
                            {{scope.row.d6 | thousandth}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="d7" label="比率" align="right"></el-table-column>
                    <el-table-column prop="d8" label="23年人件费事业计划预算" >
                        <template slot-scope="scope">
                            {{scope.row.d8 | thousandth}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="d9" label="月均" align="right">
                        <template slot-scope="scope">
                            {{scope.row.d9 | thousandth}}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip fixed="right" :label="$t('getapi[6048]')" width="80">
                        <template slot-scope="scope">
                            <span @click="commit(scope.row)">原因分析</span>
                        </template>
                    </el-table-column>
                </el-table>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <table>
                    <tr>
                        <td style="width:60px">部门</td>
                        <td style="width:150px;">
                            {{dataDetail.Head.bm}}
                        </td>
                        <td style="width:60px">时间</td>
                        <td style="width:150px;">
                            {{dataDetail.Head.sj}}
                        </td>
                        <td style="width:60px">部门担当</td>
                        <td style="width:150px;">
                            <el-input type="text" size="mini" v-model="dataDetail.Head.dd"></el-input>
                        </td>
                    </tr>
                </table>
                <el-table
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        stripe
                        size="mini"
                        :height="tableHeight - 30"
                        header-row-class-name="headerclass"
                        style="width: 100%; margin-top:0px"
                        :data="dataDetail.List"
                        @selection-change="handleSelectionChange">
                    <el-table-column prop="d1" label="项次" ></el-table-column>
                    <el-table-column prop="d2" label="区分" ></el-table-column>
                    <el-table-column prop="d3" label="预算" align="right">
                        <template slot-scope="scope">
                            {{scope.row.d3 | thousandth}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="d4" label="占比" align="right"></el-table-column>
                    <el-table-column prop="d5" label="实绩" align="right">
                        <template slot-scope="scope">
                            {{scope.row.d5 | thousandth}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="d6" label="占比" align="right"></el-table-column>
                    <el-table-column prop="d7" label="差异" align="right">
                        <template slot-scope="scope">
                            {{scope.row.d7 | thousandth}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="d8" label="占比" align="right"></el-table-column>
                </el-table>
            </li>
        </ul>

        <el-dialog v-dialogDrag :visible.sync="comVisible" title="超支费用分析和对策" width="40%" :close-on-click-modal="false">
            <div class="tab">
                <table>
                <tr>
                    <td style="width:360px" colspan="3">原因分析</td>
                    <td style="width:80px">金额</td>
                    <td style="width:60px">占比</td>
                    <td style="width:160px">对策</td>
                </tr>
                <tr>
                    <td style="width:60px">1</td>
                    <td style="width:150px" rowspan="5">人件費</td>
                    <td style="width:150px;">
                        <el-input type="text" size="mini" v-model="comData.d1"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d2"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d3"></el-input>
                    </td>
                    <td rowspan="5" >
                        {{comData.d4}}
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d1"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d2"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d3"></el-input>
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d1"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d2"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d3"></el-input>
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d1"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d2"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d3"></el-input>
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d1"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d2"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d3"></el-input>
                    </td>
                </tr>
                <tr>
                    <td style="width:60px">2</td>
                    <td style="width:150px" rowspan="5">補材費</td>
                    <td style="width:150px;">
                        <el-input type="text" size="mini" v-model="comData.d1"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d2"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d3"></el-input>
                    </td>
                    <td rowspan="5">
                        {{comData.d4}}
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d1"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d2"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d3"></el-input>
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d1"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d2"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d3"></el-input>
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d1"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d2"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d3"></el-input>
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d1"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d2"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d3"></el-input>
                    </td>
                </tr>
                <tr>
                    <td style="width:60px">3</td>
                    <td style="width:150px" rowspan="5">消耗費</td>
                    <td style="width:150px;">
                        <el-input type="text" size="mini" v-model="comData.d1"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d2"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d3"></el-input>
                    </td>
                    <td rowspan="5">
                        {{comData.d4}}
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d1"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d2"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d3"></el-input>
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d1"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d2"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d3"></el-input>
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d1"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d2"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d3"></el-input>
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d1"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d2"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d3"></el-input>
                    </td>
                </tr>
                <tr>
                    <td style="width:60px">4</td>
                    <td style="width:150px" rowspan="5">通関費（进口)<br>通関費（出口）</td>
                    <td style="width:150px;">
                        <el-input type="text" size="mini" v-model="comData.d1"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d2"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d3"></el-input>
                    </td>
                    <td rowspan="5">
                        {{comData.d4}}
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d1"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d2"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d3"></el-input>
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d1"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d2"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d3"></el-input>
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d1"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d2"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d3"></el-input>
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d1"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d2"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d3"></el-input>
                    </td>
                </tr>
                <tr>
                    <td style="width:60px">5</td>
                    <td style="width:150px" rowspan="5">メンテナンス</td>
                    <td style="width:150px;">
                        <el-input type="text" size="mini" v-model="comData.d1"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d2"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d3"></el-input>
                    </td>
                    <td rowspan="5">
                        {{comData.d4}}
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d1"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d2"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d3"></el-input>
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d1"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d2"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d3"></el-input>
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d1"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d2"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d3"></el-input>
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d1"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d2"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d3"></el-input>
                    </td>
                </tr>
                <tr>
                    <td style="width:60px">6</td>
                    <td style="width:150px" rowspan="5">運賃</td>
                    <td style="width:150px;">
                        <el-input type="text" size="mini" v-model="comData.d1"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d2"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d3"></el-input>
                    </td>
                    <td rowspan="5">
                        {{comData.d4}}
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d1"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d2"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d3"></el-input>
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d1"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d2"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d3"></el-input>
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d1"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d2"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d3"></el-input>
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d1"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d2"></el-input>
                    </td>
                    <td>
                        <el-input type="text" size="mini" v-model="comData.d3"></el-input>
                    </td>
                </tr>
            </table>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="comVisible = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button type="primary" @click="confirmCommit()" size="mini" :disabled="selectData.length == 0">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag title="部门" :visible.sync="screenVisiable" width="30%">
            <vxe-table
                    border
                    row-key
                    ref="xTable1"
                    @checkbox-all="selectAllEvent"
                    @checkbox-change="selectChangeEvent"
                    class="sortable-row-demo"
                    :scroll-y="{ enabled: false }"
                    :data="tablebm"
                    :header-cell-class-name="headerCellClassName"
                    :height="400"
                    :checkbox-config="{ checkField: 'checked', trigger: 'row' }"
                    size="mini"
                    resizable
                    :keyboard-config="{ isArrow: true}"
                    row-class-name="drag-btn"
            >
                <vxe-table-column align="center" type="checkbox" width="40"></vxe-table-column>
                <vxe-table-column show-overflow-tooltip field="name" title="部门" width="200"></vxe-table-column>
            </vxe-table>
            <span slot="footer" class="dialog-footer">
				<el-button  @click="screenVisiable = false" size="mini">{{$t('getapi[6]')}}</el-button>
				<el-button type="primary" @click="search" size="mini">查询</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: 'pdca6',
        data() {
            return {
                dataSet: [],
                tableHeight: Common.tableHeight2, // 主表高度
                selectData: [],
                dataDetail: {
                    Head:{
                        bm:'',
                        sj:'',
                        dd:''
                    },
                    List:[]
                },
                comData:[],
                comVisible: false,
                screenVisiable: false,
                tablebm:[{
                    id:1,
                    name:'SMT/AI自动化系'
                },{
                    id:2,
                    name:'报关课'
                },{
                    id:3,
                    name:'调达课'
                },{
                    id:4,
                    name:'工程课'
                },{
                    id:5,
                    name:'购买课'
                },{
                    id:6,
                    name:'基板1系'
                },{
                    id:7,
                    name:'基板2系'
                },{
                    id:8,
                    name:'检查技术'
                },{
                    id:9,
                    name:'开发部'
                },{
                    id:10,
                    name:'品质保证课'
                },{
                    id:11,
                    name:'品质管理课'
                },{
                    id:12,
                    name:'生产管理课'
                },{
                    id:13,
                    name:'资材课'
                },{
                    id:14,
                    name:'自动机系'
                }]
            };
        },
        mounted: function () {
            let that = this;
            that.$limits.dragControllerDiv();
            that.getView()
        },
        methods: {
            headerCellClassName({ column, columnIndex }) {
                return 'col-blue';
            },
            handleSelectionChange(val) {
                let that = this
                that.selectData = val
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            getView() {
                let that = this
                that.dataSet = [
                    {
                        bm:'SMT/AI自动化系',
                        d1:'1588294',
                        d2:'15',
                        d3:'9626',
                        d4:'16',
                        d5:'154016',
                        d6:'1848197',
                        d7:'7.35%',
                        d8:'1581294',
                        d9:'131774',
                    },
                    {
                        bm:'报关课',
                        d1:'1588294',
                        d2:'15',
                        d3:'9626',
                        d4:'16',
                        d5:'154016',
                        d6:'1848197',
                        d7:'7.35%',
                        d8:'1581294',
                        d9:'131774',
                    },
                    {
                        bm:'波峰焊系',
                        d1:'1588294',
                        d2:'15',
                        d3:'9626',
                        d4:'16',
                        d5:'154016',
                        d6:'1848197',
                        d7:'7.35%',
                        d8:'1581294',
                        d9:'131774',
                    },
                    {
                        bm:'调达课',
                        d1:'1588294',
                        d2:'15',
                        d3:'9626',
                        d4:'16',
                        d5:'154016',
                        d6:'1848197',
                        d7:'7.35%',
                        d8:'1581294',
                        d9:'131774',
                    },
                    {
                        bm:'工程课',
                        d1:'1588294',
                        d2:'15',
                        d3:'9626',
                        d4:'16',
                        d5:'154016',
                        d6:'1848197',
                        d7:'7.35%',
                        d8:'1581294',
                        d9:'131774',
                    },
                    {
                        bm:'购买课',
                        d1:'1588294',
                        d2:'15',
                        d3:'9626',
                        d4:'16',
                        d5:'154016',
                        d6:'1848197',
                        d7:'7.35%',
                        d8:'1581294',
                        d9:'131774',
                    },
                    {
                        bm:'基板1系',
                        d1:'1588294',
                        d2:'15',
                        d3:'9626',
                        d4:'16',
                        d5:'154016',
                        d6:'1848197',
                        d7:'7.35%',
                        d8:'1581294',
                        d9:'131774',
                    },
                    {
                        bm:'基板2系',
                        d1:'1588294',
                        d2:'15',
                        d3:'9626',
                        d4:'16',
                        d5:'154016',
                        d6:'1848197',
                        d7:'7.35%',
                        d8:'1581294',
                        d9:'131774',
                    },
                    {
                        bm:'检查技术',
                        d1:'1588294',
                        d2:'15',
                        d3:'9626',
                        d4:'16',
                        d5:'154016',
                        d6:'1848197',
                        d7:'7.35%',
                        d8:'1581294',
                        d9:'131774',
                    },
                    {
                        bm:'开发部',
                        d1:'1588294',
                        d2:'15',
                        d3:'9626',
                        d4:'16',
                        d5:'154016',
                        d6:'1848197',
                        d7:'7.35%',
                        d8:'1581294',
                        d9:'131774',
                    },
                    {
                        bm:'品质保证课',
                        d1:'1588294',
                        d2:'15',
                        d3:'9626',
                        d4:'16',
                        d5:'154016',
                        d6:'1848197',
                        d7:'7.35%',
                        d8:'1581294',
                        d9:'131774',
                    },
                    {
                        bm:'品质管理课',
                        d1:'1588294',
                        d2:'15',
                        d3:'9626',
                        d4:'16',
                        d5:'154016',
                        d6:'1848197',
                        d7:'7.35%',
                        d8:'1581294',
                        d9:'131774',
                    },
                    {
                        bm:'生产管理课',
                        d1:'1588294',
                        d2:'15',
                        d3:'9626',
                        d4:'16',
                        d5:'154016',
                        d6:'1848197',
                        d7:'7.35%',
                        d8:'1581294',
                        d9:'131774',
                    },
                    {
                        bm:'资材课',
                        d1:'1588294',
                        d2:'15',
                        d3:'9626',
                        d4:'16',
                        d5:'154016',
                        d6:'1848197',
                        d7:'7.35%',
                        d8:'1581294',
                        d9:'131774',
                    },
                    {
                        bm:'自动机系',
                        d1:'1588294',
                        d2:'15',
                        d3:'9626',
                        d4:'16',
                        d5:'154016',
                        d6:'1848197',
                        d7:'7.35%',
                        d8:'1581294',
                        d9:'131774',
                    },
                    {
                        bm:'合计',
                        d1:'1588294',
                        d2:'15',
                        d3:'9626',
                        d4:'16',
                        d5:'154016',
                        d6:'1848197',
                        d7:'7.35%',
                        d8:'1581294',
                        d9:'131774',
                    },
                ]
            },
            editInfo(row){
                let that = this
                that.dataDetail.Head.bm = row.bm
                that.dataDetail.Head.sj = '2023-2-23'
                that.dataDetail.List = [
                    {
                        d1:'',
                        d2:'销售收入',
                        d3:'53054245',
                        d4:'',
                        d5:'53054245',
                        d6:'',
                        d7: '',
                        d8: '',
                    },
                    {
                        d1:'',
                        d2:'产值',
                        d3:'57997373',
                        d4:'',
                        d5:'57997373',
                        d6:'',
                        d7: '',
                        d8: '',
                    },
                    {
                        d1:'',
                        d2:'人件费(月平均值 ）',
                        d3:'53763',
                        d4:'',
                        d5:'',
                        d6:'',
                        d7: '',
                        d8: '',
                    },
                    {
                        d1:'1',
                        d2:'人件費　(間接のみ)',
                        d3:'39923',
                        d4:'0.069%',
                        d5:'60061',
                        d6:'0.104%',
                        d7: '6299',
                        d8: '0.035%',
                    },
                    {
                        d1:'2',
                        d2:'補材費',
                        d3:'-',
                        d4:'',
                        d5:'',
                        d6:'0.000%',
                        d7: '-',
                        d8: '0.000%',
                    },
                    {
                        d1:'3',
                        d2:'消耗費、办公、劳保',
                        d3:'1273',
                        d4:'0.002%',
                        d5:'712',
                        d6:'0.001%',
                        d7: '-560',
                        d8: '-0.001%',
                    },
                    {
                        d1:'4',
                        d2:'通関費（进口）',
                        d3:'-',
                        d4:'',
                        d5:'',
                        d6:'',
                        d7: '-',
                        d8: '-0.000%',
                    },
                    {
                        d1:'',
                        d2:'通関費（出口）',
                        d3:'-',
                        d4:'',
                        d5:'',
                        d6:'',
                        d7: '-',
                        d8: '-0.000%',
                    },
                    {
                        d1:'5',
                        d2:'メンテナンス',
                        d3:'',
                        d4:'',
                        d5:'',
                        d6:'0.000%',
                        d7: '-1',
                        d8: '0.000%',
                    },
                    {
                        d1:'6',
                        d2:'運賃',
                        d3:'4632',
                        d4:'0.008%',
                        d5:'',
                        d6:'0.000%',
                        d7: '-4632',
                        d8: '-0.008%',
                    },
                ]
            },
            //查询
            search(){
                let that = this
            },
            commit(){
                let that = this
                that.comData = [
                ]
                that.comVisible = true
            },
            confirmCommit(){
                let that = this
                that.comVisible = false
            },
            //筛选展示行
            screen(){
                let that = this
                that.screenVisiable = true
            },
        }
    };
</script>

<style scoped lang="less">
    table{
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    .tab{
        border-collapse: separate;
        border-spacing: 0px 5px;
        border: 1px solid #EBEEF5;
        td {
            padding-left: 3px;
            white-space: pre;
            border: 1px solid #EBEEF5;
        }
    }
</style>
